// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/TCCC-UnityHeadline Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/TCCC-UnityText Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/RobotoCondensed-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'TCCC-UnityHeadline Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'TCCC-UnityText Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoCondensed';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

html, body {
  font-family: 'TCCC-UnityHeadline Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Garante que a cadeia flex funcione para scroll no react-native-web */
#root > div {
  height: 100%;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/web/fonts.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,+DAA6E;EAC7E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+DAAsE;EACtE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAAoF;EACpF,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4GAA4G;AAC9G;;AAEA,uEAAuE;AACvE;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["@font-face {\n  font-family: 'TCCC-UnityHeadline Regular';\n  src: url('../assets/fonts/TCCC-UnityHeadline Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'TCCC-UnityText Bold';\n  src: url('../assets/fonts/TCCC-UnityText Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoCondensed';\n  src: url('../assets/fonts/RobotoCondensed-VariableFont_wght.ttf') format('truetype');\n  font-weight: 100 900;\n  font-style: normal;\n}\n\nhtml, body {\n  font-family: 'TCCC-UnityHeadline Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Garante que a cadeia flex funcione para scroll no react-native-web */\n#root > div {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
